import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { scrollTo } from "@/utils/scroll-to";

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 50, 100, 200, 500];
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
    // effectiveTotal: {
    //   type: Number,
    // },
  },

  computed: {
    currentPage: {
      get: function get() {
        return this.page;
      },
      set: function set(val) {
        this.$emit('update:page', val);
      }
    },
    pageSize: {
      get: function get() {
        return this.limit;
      },
      set: function set(val) {
        this.$emit('update:limit', val);
      }
    }
  },
  watch: {
    // effectiveTotal: {
    //   handler(newVal, oldVal) {
    //     console.log(newVal,'newval')
    //     if (newVal == 0) {
    //       this.$message({
    //         message: "完整数据在前63页左右,特殊情况除外",
    //         type: "warning",
    //       });
    //     }
    //   },
    //   deep: true, // 是否深度监听
    //   // immediate: true, // 是否在组件创建时立即执行回调函数
    // },
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('pagination', {
        page: this.currentPage,
        limit: val
      });
      if (this.autoScroll) {
        // console.log(this.autoScroll,'auto')
        // scrollTo(100, 800);
        this.$parent.$refs.mainTable.$el.scrollIntoView(); // 用于将指定元素滚动到可见区域内的方法--百度
        // console.log('执行了handleSizeChange')
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('pagination', {
        page: val,
        limit: this.pageSize
      });
      if (this.autoScroll) {
        // scrollTo(100, 800);
        this.$parent.$refs.mainTable.$el.scrollIntoView();
        // console.log('执行了handleCurrentChange')
      }
    }
  }
};